import src from "IMAGE";
export default { src, width: 600, height: 453, blurWidth: 0, blurHeight: 0};
